export const organizationSizes = [
  { value: '0', label: '1' },
  { value: '2', label: '2-10' },
  { value: '11', label: '11-50' },
  { value: '51', label: '51-200' },
  { value: '201', label: '201-500' },
  { value: '501', label: '501-1000' },
  { value: '1001', label: '1001-5000' },
  { value: '5001', label: '5001-10000' },
  { value: '10001', label: '10000+' },
];

export const organizationTypes = [
  { value: 'educational', label: 'Educational Institution' },
  { value: 'government_agency', label: 'Government Agency' },
  { value: 'non_profit', label: 'Non-Profit' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'privately_held', label: 'Privately Held' },
  { value: 'public_company', label: 'Public Company' },
  { value: 'self_employed', label: 'Self-Employed' },
  { value: 'self_owned', label: 'Self-Owned' },
];

export const WORKSPACE_UPDATED_EVENT = 'workspaceUpdated'; 